import { render } from "./pathAnimation.vue?vue&type=template&id=b146435e"
import script from "./pathAnimation.vue?vue&type=script&lang=js"
export * from "./pathAnimation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__